import { render, staticRenderFns } from "./UnauthorizedPage.vue?vue&type=template&id=24b47746&scoped=true&"
import script from "./UnauthorizedPage.vue?vue&type=script&lang=ts&"
export * from "./UnauthorizedPage.vue?vue&type=script&lang=ts&"
import style0 from "./UnauthorizedPage.vue?vue&type=style&index=0&id=24b47746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b47746",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VContainer,VMain})
